<!-- Divider -->
<div
    class="devstroupe-horizontal-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
